import {ReviewsSection_ReviewSummary} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {Flyout} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {useReviewsFlyoutStateManager} from '../utils/useReviewsFlyoutStateManager';
import {OverallRating, OverallRatingProps} from './OverallRating';
import {UserReviewCard} from './UserReviewCard';

export const ReviewsFlyout: FC<
  OverallRatingProps & {
    showcaseReviews: ReviewsSection_ReviewSummary['showcaseReviews'];
  }
> = ({
  reviewCount,
  overallStarRating,
  overallRating,
  showcaseReviews,
  reduceBottomMargin,
}) => {
  const {cancel, isOpen} = useReviewsFlyoutStateManager();

  return (
    <Flyout
      open={isOpen}
      data-testid="ratingsAndReviewsFlyout"
      onClose={cancel}
      headerContent={
        <OverallRating
          reviewCount={reviewCount}
          overallStarRating={overallStarRating}
          overallRating={overallRating}
          reduceBottomMargin={reduceBottomMargin}
        />
      }
      bodyContent={
        <FlyoutContentWrapper>
          {showcaseReviews.map((showcaseReview, index) => (
            <UserReviewCard
              showcaseReview={showcaseReview}
              key={`userReviewCard-tile-${index}`}
            />
          ))}
        </FlyoutContentWrapper>
      }
    />
  );
};

const FlyoutContentWrapper = styled.div`
  overflow: auto;
`;
